module.exports = __webpack_public_path__ + "img/bg-section-07.27471b14.svg";